import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useTranslation } from 'react-i18next';
import { EnergyType } from 'services/api/entities';
import aiMusicGenerator from 'services/locales/en/aiMusicGenerator';
import { ControlComponentProps } from '../types';

type EnergySelectorProps = ControlComponentProps<EnergyType>;

const EnergySelector = ({ value, onChange }: EnergySelectorProps) => {
  const { t } = useTranslation();

  return (
    <RadioGroup
      row
      aria-labelledby="energy-selector"
      defaultValue={EnergyType.ORIGINAL}
      value={value}
      onChange={({ target }) => onChange(target.value as EnergyType)}
      name="energy"
      sx={{
        justifyContent: 'space-evenly',
      }}
    >
      <FormControlLabel
        value={EnergyType.LOW}
        control={<Radio />}
        label={t(aiMusicGenerator.energy.low)}
      />
      <FormControlLabel
        value={EnergyType.ORIGINAL}
        control={<Radio />}
        label={t(aiMusicGenerator.energy.original)}
      />
      <FormControlLabel
        value={EnergyType.HIGH}
        control={<Radio />}
        label={t(aiMusicGenerator.energy.high)}
      />
    </RadioGroup>
  );
};

export default EnergySelector;
